"use strict";

const Debug = require('debug');

const {
  getAddress
} = require('./wallet');

const {
  getAuthorization,
  httpRequest
} = require('../utils/api-utils');

const {
  throwIfMissing
} = require('../utils/validator');

const debug = Debug('iexec:result-proxy');

const login = async function () {
  let contracts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : throwIfMissing();
  let resultProxyURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : throwIfMissing();

  try {
    const userAddress = await getAddress(contracts);
    const authorization = await getAuthorization(resultProxyURL, '/results/challenge')(contracts.chainId, userAddress, contracts.signer);
    const res = await httpRequest('POST')({
      api: resultProxyURL,
      endpoint: '/results/login',
      query: {
        chainId: contracts.chainId
      },
      body: authorization
    }).catch(e => {
      debug(e);
      throw Error("Result Proxy at ".concat(resultProxyURL, " didn't answered"));
    });

    if (res.ok) {
      const token = await res.text();
      return token;
    }

    throw Error("Result Proxy login failed: ".concat(res.status, " ").concat(res.statusText));
  } catch (error) {
    debug('login()', error);
    throw error;
  }
};

module.exports = {
  login
};